const INITIAL_STATE = {
  listaGlosas: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'GLOSA_RECEBER_GOLSAS_DE_ENTE':
      return { ...state, listaGlosas: action.payload };
    case 'GLOSA_RECEBER_GOLSA':
      return { ...state, glosa: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/glosas/reducer.js